import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from './baseQuery';

export interface ProductCategory {
  _id: string;
  name: string;
  created_at: string;
  updated_at: string;
}

export interface CreateProductCategoryDto {
  name: string;
}

export interface UpdateProductCategoryDto {
  name: string;
}

export const productCategoriesApi = createApi({
  reducerPath: 'productCategoriesApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['ProductCategories'],
  endpoints: (builder) => ({
    getProductCategories: builder.query<ProductCategory[], void>({
      query: () => '/product-categories',
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: 'ProductCategories' as const, id: _id })),
              { type: 'ProductCategories', id: 'LIST' },
            ]
          : [{ type: 'ProductCategories', id: 'LIST' }],
    }),
    getProductCategory: builder.query<ProductCategory, string>({
      query: (id) => `/product-categories/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'ProductCategories', id }],
    }),
    createProductCategory: builder.mutation<ProductCategory, CreateProductCategoryDto>({
      query: (data) => ({
        url: '/product-categories',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'ProductCategories', id: 'LIST' }],
    }),
    updateProductCategory: builder.mutation<ProductCategory, { id: string; category: UpdateProductCategoryDto }>({
      query: ({ id, category }) => ({
        url: `/product-categories/${id}`,
        method: 'PATCH',
        body: category,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'ProductCategories', id },
        { type: 'ProductCategories', id: 'LIST' },
      ],
    }),
    deleteProductCategory: builder.mutation<void, string>({
      query: (id) => ({
        url: `/product-categories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: 'ProductCategories', id },
        { type: 'ProductCategories', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetProductCategoriesQuery,
  useGetProductCategoryQuery,
  useCreateProductCategoryMutation,
  useUpdateProductCategoryMutation,
  useDeleteProductCategoryMutation,
} = productCategoriesApi; 